enum SizeFilters {
  IS_SQUARE = 'IsSquare',
  IS_STANDARD = 'IsStandard',
}

export default SizeFilters;
